import { PupilAttendanceSchedule, SchoolCalendarException } from '@core/models/domain/school-calendar.domain';

export interface SchoolCalendarState {
  /** What the last read returned. */
  exceptions: SchoolCalendarException[];
  schedules: PupilAttendanceSchedule[];
  /**
   * Writes the page has made that a read has not shown yet. The backend takes a
   * write as a command and projects it into what a read returns a moment later,
   * so these are held alongside the read's own answer and merged into it by the
   * selectors; each one is dropped as soon as a read comes back carrying it.
   */
  pendingExceptions: SchoolCalendarException[];
  pendingSchedules: PupilAttendanceSchedule[];
  /** Pupil account ids taken off an individual timetable but still in the last read. */
  pendingScheduleRemovals: string[];
  loading: boolean;
  saving: boolean;
  error: string | null;
  /** Id of the exception currently being withdrawn, so its row can disable its own button. */
  cancellingId: string | null;
}

export const initialSchoolCalendarState: SchoolCalendarState = {
  exceptions: [],
  schedules: [],
  pendingExceptions: [],
  pendingSchedules: [],
  pendingScheduleRemovals: [],
  loading: false,
  saving: false,
  error: null,
  cancellingId: null,
};
